/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const LeftArrow: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="left-arrow" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M1133.3475 736.6525H443.7000000000001L760.4525 1053.405L680 1133.305L226.6525 679.9575000000001L680 226.6100000000002L759.9 306.51L443.7 623.2624999999999H1133.3474999999999V736.6099999999999z" : "M906.6780000000002 589.322H354.9600000000001L608.3620000000001 842.724L544 906.644L181.322 543.9660000000001L544 181.288L607.92 245.208L354.9599999999999 498.61H906.6779999999998V589.288z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
LeftArrow.displayName = `Blueprint5.Icon.LeftArrow`;
export default LeftArrow;
